<template>
  <responsive-modal v-model="visible">
    <div class="tool-modal-hotzapp p-5">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div>
        <strong>
          Integração Hotzapp
        </strong>
      </div>
      <div class="d-flex align-items-center mb-5">
        <small class="text-dark flex-fill mt-5">
          <a
            target="_blank"
            href="https://www.hotzapp.com/"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça a Hotzapp
          </a>
        </small>
      </div>
      <hr />
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <form-group
          :disabled="form.id != null"
          slim
          select
          id="product-select"
          label="Nome do produto"
          v-model="form.product_id"
          :errors="errors.product_id"
          placeholder="Selecionar produto..."
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <form-group
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
        :errors="errors.description"
        placeholder="Digite a descrição da integração..."
      />
      <action-dispatcher action="integration/getTypeEvents">
        <form-group
          select
          multiple
          label="Eventos disparados"
          id="events-select"
          v-model="form.events"
          placeholder="Selecionar eventos..."
          :options="typeEvents"
          :errors="errors.events"
        />
      </action-dispatcher>
      <form-group
        label="URL"
        id="url"
        v-model="form.url"
        :errors="errors.url"
        placeholder="Digite a URL..."
      />
      <div class="d-flex justify-content-center pt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'bg-secondary border-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["description", "status", "events", "url", "product_id"], {
        events: []
      }),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
        this.form.events = v.events.map(e => e.event);
      }
    }
  },
  computed: {
    ...mapState("integration", ["typeEvents"]),
    ...mapState("product", ["products"]),
    isValid() {
      return this.form.events.length && this.form.product_id && this.form.url;
    }
  },
  methods: {
    clear() {
      this.form = { events: [] };
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.loading = false;
      this.visible = false;
      this.$emit("loading");
      setTimeout(() => {
        this.$emit("update-list");
      }, 5200);
      this.clear();
    },
    submit() {
      if (this.loading) return;

      this.loading = true;

      this.form.events = this.form.events.map(e => {
        return { event: e };
      });
      const data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("A integração foi salva!");
          this.onSubmit();
        })
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar integração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-hotzapp {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
